export const sayAsMenuOptions = [
  {
    menuName: "Number",
    menuOptions: [
      "Cardinal",
      "Ordinal",
      "Decimal",
      "Digits",
      "Fractions",
      "Roman",
    ],
  },
  {
    menuName: "Date",
    menuOptions: [
      "ymd (year-month-day)",
      "mdy (month-day-year)",
      "dmy (day-month-year)",
      "ym (year-month)",
      "my (month-year)",
      "md (month-day)",
      "dm (day-month)",
      "y (year)",
      "m (month)",
      "d (day)",
    ],
  },
  {
    menuName: "Time",
    menuOptions: ["hms12", "hms24"],
  },
  { menuName: "Unit" },
  { menuName: "Currency" },
  { menuName: "Characters" },
  { menuName: "Spell-out" },
];
